import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Tuto } from "./pages";

export const TutoRouter = [
  <Route
    path="/tuto"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Tuto />
      </ProtectedRoute>
    }
  />,
];
